import { address } from "$store/sdk/shipping.ts";
import Icon from "$store/components/ui/Icon.tsx";

export default function SelectedAddress() {
  return (
    <div class="flex gap-1 lg:flex-col sm:gap-4 lg:gap-0">
      <span class="text-white text-xs font-maven font-medium sm:text-sm lg:text-tw-neutral-500">
        Entrega em: {!!address.value.postalCode &&
          (
            <span class="font-bold">
              {address.value.city}, {address.value.postalCode}
            </span>
          )}
      </span>

      <span class="text-white text-xs font-maven font-medium underline flex items-center gap-2 sm:text-sm lg:text-tw-neutral-300 lg:gap-5">
        {address.value.postalCode ? "Trocar meu CEP" : "Digite seu CEP"}

        <Icon
          id="ArrowBottom"
          class="text-tw-primary-100"
          width={12}
          height={7}
        />
      </span>
    </div>
  );
}
